module.exports = __webpack_public_path__ + "media/images/header-logo-b49301c9247133eb6fe931d1b0938e27.png";